import { useStyletron } from "baseui";
import { StyledSvg } from "baseui/icon";
import React from "react";

export const MarketingTipIcon = (props: React.ComponentProps<typeof StyledSvg> & { $disabled: boolean }) => {
  const [_, $theme] = useStyletron();
  const fill = props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : "currentcolor");

  return (
    <StyledSvg
      viewBox="0 0 48 48"
      $style={{ minHeight: "48px", minWidth: "48px" }}
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5833 16.2096C17.0177 16.2096 18.1805 15.0468 18.1805 13.6124C18.1805 12.178 17.0177 11.0151 15.5833 11.0151C14.1489 11.0151 12.9861 12.178 12.9861 13.6124C12.9861 15.0468 14.1489 16.2096 15.5833 16.2096Z"
        fill={fill}
      />
      <path
        d="M31.1666 16.2096C32.601 16.2096 33.7638 15.0468 33.7638 13.6124C33.7638 12.178 32.601 11.0151 31.1666 11.0151C29.7322 11.0151 28.5693 12.178 28.5693 13.6124C28.5693 15.0468 29.7322 16.2096 31.1666 16.2096Z"
        fill={fill}
      />
      <path
        d="M23.5117 26.1868C21.4939 26.1868 19.4746 25.3245 17.938 23.5999C17.3501 22.9401 17.3501 21.8736 17.938 21.2138C18.5259 20.554 19.4761 20.554 20.064 21.2138C21.966 23.3468 25.0574 23.3468 26.9594 21.2138C27.5472 20.554 28.4975 20.554 29.0854 21.2138C29.6733 21.8736 29.6733 22.9401 29.0854 23.5999C27.5488 25.3245 25.5295 26.1868 23.5117 26.1868Z"
        fill={fill}
      />
      <path
        d="M38.9583 0.625H7.79167C3.48807 0.625 0 4.11307 0 8.41667V39.5833C0 43.8869 3.48807 47.375 7.79167 47.375H38.9583C43.2619 47.375 46.75 43.8869 46.75 39.5833V8.41667C46.75 4.11307 43.2619 0.625 38.9583 0.625ZM25.9722 42.1806H10.3889C8.95522 42.1806 7.79167 41.017 7.79167 39.5833C7.79167 38.1497 8.95522 36.9861 10.3889 36.9861H25.9722C27.4059 36.9861 28.5694 38.1497 28.5694 39.5833C28.5694 41.017 27.4059 42.1806 25.9722 42.1806ZM36.3611 42.1806C34.9274 42.1806 33.7639 41.017 33.7639 39.5833C33.7639 38.1497 34.9274 36.9861 36.3611 36.9861C37.7948 36.9861 38.9583 38.1497 38.9583 39.5833C38.9583 41.017 37.7948 42.1806 36.3611 42.1806ZM38.9583 26.5972C38.9583 29.4672 36.6338 31.7917 33.7639 31.7917H12.9861C10.1162 31.7917 7.79167 29.4672 7.79167 26.5972V11.0139C7.79167 8.14396 10.1162 5.81944 12.9861 5.81944H33.7639C36.6338 5.81944 38.9583 8.14396 38.9583 11.0139V26.5972Z"
        fill={fill}
      />
    </StyledSvg>
  );
};
